<template>
  <v-card>
    <v-card-title> Create Print Brochure </v-card-title>
    <v-card-text>
      <v-btn color="success" disabled class="mr-2" @click.stop="downloadCatalog()">
        Download catalog of all images
        <v-icon class="ml-4"> mdi-download </v-icon>
      </v-btn>
      <v-radio-group v-if="artistGiclees" v-model="type" row @change="setType">
        <v-radio label="Artists Brochure" value="artist"></v-radio>
        <!-- <v-radio
        label="Regional Brochure"
        value="region"
      ></v-radio>
      <v-radio
        label="Latest Images"
        value="latest"
      ></v-radio> -->
      </v-radio-group>
      <div class="d-flex mt-4" v-if="filteredGiclees && type === 'artist'">
        <v-autocomplete
          class="mr-2"
          v-model="selectedArtist"
          :items="artists"
          outlined
          clearable
          clear-icon="mdi-close-box"
          dense
          item-text="artist"
          :return-object="true"
          :label="'Artist'"
        ></v-autocomplete>
      </div>
      <v-card-text v-if="artistsLoading" class="mt-4 text-center">
        <h2 class="mt-4 mb-4 text-center">Loading artists...</h2>
        <v-progress-circular
          indeterminate
          :size="30"
          :width="3"
          color="green"
        ></v-progress-circular>
      </v-card-text>
      <div class="d-flex mt-4" v-if="regions.length && type === 'region'">
        <v-autocomplete
          class="mr-2"
          v-model="selectedRegion"
          :items="regions"
          outlined
          clearable
          clear-icon="mdi-close-box"
          dense
          :label="'Regions'"
        ></v-autocomplete>
      </div>
      <v-btn
        v-if="selectedArtist"
        color="success"
        class="mr-2"
        @click.stop="downloadArtistBrochure(selectedArtist)"
      >
        Download Artist Brochure
        <v-icon class="ml-4"> mdi-download </v-icon>
      </v-btn>
      <v-btn
        v-if="selectedArtist"
        color="success"
        @click.stop="downloadImagesZip(selectedArtist)"
      >
        Download giclee images
        <v-icon class="ml-4"> mdi-download </v-icon>
      </v-btn>
      <v-card-text v-if="loading" class="mt-4 text-center">
        <h2 class="mt-4 mb-4 text-center">{{ loadingText }}</h2>
        <v-progress-circular
          indeterminate
          :size="70"
          :width="7"
          color="green"
        ></v-progress-circular>
      </v-card-text>
      <h3 class="my-2" v-if="filteredGiclees.artworks && !loading">
        Note: Artwork images are still being sorted out - there are some mismatches /
        ommissions. Current image column is only there for sanity check until all are
        confirmed
      </h3>
      <v-data-table
        v-if="filteredGiclees.artworks && !loading"
        :items="filteredGiclees.artworks"
        item-key="artwork"
        :headers="headers"
        :footer-props="{
          itemsPerPageOptions: [50, 100, 250],
        }"
        :sort-by="['artistCollection', 'aspect']"
        :sort-desc="[false, false]"
        multi-sort
        dense
      >
        <template v-slot:item.gicleeBrochure="{ item }">
          <v-checkbox @change="setGicleeBrochure(item)" v-model="item.gicleeBrochure" />
        </template>
        <template v-slot:[`item.artworkImage`]="{ item }">
          <div class="d-flex">
            <v-img
              height="100px"
              contain
              :src="`${imageUrl}/100px/${item.artworkImage}`"
            ></v-img>
          </div>
        </template>
        <template v-slot:[`item.thumb`]="{ item }">
          <div class="d-flex">
            <v-img
              height="100px"
              contain
              :src="`${imageUrl}/artwork-images/100px/${item.artworkCode}-PRINT.jpg`"
            ></v-img>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import ArtistApi from "@/api/admin/artist";
import ArtworkApi from "@/api/admin/artwork";
import ProductApi from "@/api/admin/product";
import TrelloApi from "@/api/admin/trello";

export default {
  data() {
    return {
      type: null,
      imageUrl: process.env.VUE_APP_IMG_URL,
      selectedArtist: null,
      selectedRegion: null,
      regionalGiclees: null,
      artistGiclees: null,
      giclees: [],
      loading: false,
      artistsLoading: true,
      loadingText: null,
      headers: [
        // { text: "Current Image", value: "artworkImage" },
        { text: "New Image", value: "thumb" },
        { text: "Title", value: "title" },
        { text: "Artwork", value: "artworkCode" },
        { text: "Collection", value: "artistCollection" },
        { text: "Aspect", value: "aspect" },
        { text: "Sales", value: "sales" },
        { text: "Giclee Brochure", value: "gicleeBrochure" },
      ],
    };
  },
  async created() {
    ArtistApi.loadRegionalGiclees().then((res) => {
      this.regionalGiclees = res.data;
    });
    ArtistApi.loadArtistGiclees({ artistCodes: [] }).then((res) => {
      this.artistsLoading = true;
      this.artistGiclees = res.data;
      this.artistsLoading = false;
    });
    TrelloApi.getBoards().then((res) => {
      console.log(res.data);
    });
  },
  computed: {
    filter() {
      const obj = {};
      this.selectedArtist && (obj.artistCode = this.selectedArtist.artistCode);
      this.selectedRegion && (obj.region = this.selectedRegion);
      return obj;
    },
    filteredGiclees() {
      return this.selectedArtist || this.selectedRegion
        ? _.filter(this.giclees, this.filter)[0]
        : [];
    },
    artists() {
      return _.orderBy(
        _.uniq(
          this.giclees.map((a) => {
            return { artist: a.artist, artistCode: a.artistCode };
          })
        ),
        ["artist"],
        ["asc"]
      );
    },
    regions() {
      return this.giclees.map((a) => {
        return a.region;
      });
    },
  },
  methods: {
    async setType(evt) {
      this.giclees = [];
      switch (evt) {
        case "region":
          this.selectedArtist = null;
          this.giclees = this.regionalGiclees;
          break;
        case "artist":
          this.selectedRegion = null;
          this.giclees = this.artistGiclees;
          break;
      }
    },
    async downloadCatalog(selectedArtist) {
      this.loadingText = "Please wait while we generate the brochure";
      this.loading = true;
      ProductApi.getCatalogPDF({
        artistCodes: selectedArtist.artistCode ? [selectedArtist.artistCode] : [],
      }).then((results) => {
        this.loading = false;
      });
    },
    async downloadArtistBrochure(selectedArtist) {
      this.loadingText = "Please wait while we generate the brochure";
      this.loading = true;
      ProductApi.getArtistBrochurePDF({
        artistCodes: selectedArtist.artistCode ? [selectedArtist.artistCode] : [],
      }).then((results) => {
        this.loading = false;
      });
    },

    async downloadImagesZip(selectedArtist) {
      this.loadingText = "Please wait while we create the zip file";
      this.loading = true;
      ProductApi.getImagesZip(selectedArtist).then((results) => {
        this.loading = false;
      });
    },
    async setGicleeBrochure({ artworkCode, gicleeBrochure }) {
      ArtworkApi.updateArtwork({ artworkCode, gicleeBrochure }).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>
